import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_CUISINE_TYPE_MUTATION } from '../graphql/mutations'
import { DELETE_CUISINE_TYPE } from '../redux/action-types'

const useDeleteCuisineTypeMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.cuisineTypes.cuisineTypes,
  )

  const mutate = useCallback(
    async id => {
      await apolloService.mutate(
        DELETE_CUISINE_TYPE_MUTATION,
        {
          id,
        },
        dispatch,
        DELETE_CUISINE_TYPE,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteCuisineTypeMutation
